export default __webpack_public_path__ + "static/veloceo-bdc282de54bdfbd679d1f2ef01f3b52d.svg";